/**
 * Formats payment method lines within form data for API submission.
 * @param formData The raw form data object containing payment line arrays.
 * @returns A new object with payment lines formatted for the API.
 */
export function formatPaymentMethodsForAPI(formData: any) {
	const formatLine = (line: any) => {
		let type: 0 | 1 | 2 | 3 | undefined;

		switch (line.code) {
			case "BT":
				type = 0;
				break;
			case "CASH":
				type = 1;
				break;
			case "CHK":
				type = 2;
				break;
			case "CC":
				type = 3;
				break;
			default:
				type = undefined; // Or handle unknown codes as needed
		}

        if ( type === undefined ) {
            type = line.id; // Fallback to line.id if type is not determined
        }

		// Ensure only relevant properties are included and formatted correctly
		const out: any = {
			date: line.date,
			amount: line.amount,
			payment_type: type,
		};

		// Preserve optional payment details when present (used by checks / bank transfer / credit card).
		[
			'reference',
			'bank',
			'branch',
			'account',
			'credit_card_code',
			'credit_card_name',
			'credit_type',
		].forEach((k) => {
			const v = (line as any)?.[k];
			if (v !== undefined && v !== null && v !== '') {
				out[k] = v;
			}
		});

		return out;
	};

	// Helper to safely map arrays, returning empty array if input is not an array
	const safeMap = (arr: any, callback: (item: any) => any) => 
		Array.isArray(arr) ? arr.map(callback) : [];

	const formatted = {
		...formData, // Spread the original form data
		// Replace original arrays with formatted ones
		linesCash: safeMap(formData.linesCash, formatLine),
		linesChecks: safeMap(formData.linesChecks, formatLine),
		linesBankPayment: safeMap(formData.linesBankPayment, formatLine),
		linesCredit: safeMap(formData.linesCredit, formatLine),
	};

	return formatted;
}
